import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Map embed',
  name: 'mapEmbed',
  type: 'object',
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      description: `Component identifier within sanity. Doesn't render on the frontend`,
      type: 'string',
    }),
    defineField({
      name: 'embedCode',
      title: 'Embed code',
      description: `Use iframe embed method. This component should be used only for map embeds since it's constrained to certain aspect ratio on frontend`,
      type: 'text',
      validation: (rule) => rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: title || 'Untitled',
        subtitle: 'Map embed',
      }
    },
  },
})